import { render, staticRenderFns } from "./LinkContact.vue?vue&type=template&id=d09f5fee&"
import script from "./LinkContact.vue?vue&type=script&lang=js&"
export * from "./LinkContact.vue?vue&type=script&lang=js&"
import style0 from "./LinkContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports